import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, X, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export function AnnouncementBar() {
  const [cfg, setCfg] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("fs_announce_hidden") === "1");
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/storefront").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg?.announcement_enabled || hidden || !cfg.announcement_text) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(cfg.announcement_promo_code); setCopied(true); toast.success(`Code ${cfg.announcement_promo_code} copied — paste it at checkout`); setTimeout(() => setCopied(false), 2000); }
    catch { toast.info(`Use code ${cfg.announcement_promo_code} at checkout`); }
  };
  const dismiss = () => { sessionStorage.setItem("fs_announce_hidden", "1"); setHidden(true); };
  const link = cfg.announcement_link || "/shop";
  const external = /^https?:\/\//.test(link);

  return (
    <div data-testid="announcement-bar" className="bg-[#0a192f] text-white text-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 relative">
        <Tag className="w-4 h-4 text-[#d4af37] flex-shrink-0" />
        {external ? <a href={link} className="hover:text-[#d4af37]" data-testid="announcement-text">{cfg.announcement_text}</a> : <Link to={link} className="hover:text-[#d4af37]" data-testid="announcement-text">{cfg.announcement_text}</Link>}
        {cfg.announcement_promo_code && (
          <button data-testid="announcement-copy" onClick={copy} className="inline-flex items-center gap-1.5 bg-[#d4af37] text-[#0a192f] font-bold tracking-widest px-2.5 py-1 text-xs hover:bg-white transition-colors">
            {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {cfg.announcement_promo_code}
          </button>
        )}
        <button data-testid="announcement-dismiss" onClick={dismiss} aria-label="Dismiss" className="absolute right-4 lg:right-8 text-white/60 hover:text-white"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
